import { render, staticRenderFns } from "./tribe-box-image-text.vue?vue&type=template&id=552d5806&scoped=true&"
import script from "./tribe-box-image-text.vue?vue&type=script&lang=js&"
export * from "./tribe-box-image-text.vue?vue&type=script&lang=js&"
import style0 from "./tribe-box-image-text.vue?vue&type=style&index=0&id=552d5806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d5806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552d5806')) {
      api.createRecord('552d5806', component.options)
    } else {
      api.reload('552d5806', component.options)
    }
    module.hot.accept("./tribe-box-image-text.vue?vue&type=template&id=552d5806&scoped=true&", function () {
      api.rerender('552d5806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/tribe-box-image-text.vue"
export default component.exports